import { PiChartLineUpBold } from "react-icons/pi";
import { AiFillDatabase } from "react-icons/ai";
import { ImTarget } from "react-icons/im";
import { FaClipboardList } from "react-icons/fa";

export const aboutCardData = [
  {
    icons: <PiChartLineUpBold />,
    title: "Research",
    content:
      "As a digital marketing agency, our process begins with thorough research to understand market trends and consumer behavior.",
  },
  {
    icons: <AiFillDatabase />,
    title: "Data Collection",
    content:
      "We meticulously collect relevant data to inform our strategies and optimize targeting for maximum reach and engagement.",
  },
  {
    icons: <ImTarget />,
    title: "Targeting",
    content:
      "Utilizing advanced analytics tools, we refine our approach to ensure that our campaigns deliver measurable results for our clients.",
  },
  {
    icons: <FaClipboardList />,
    title: "Result",
    content:
      "As a digital marketing agency, we research markets and collect data for precise targeting, ensuring impactful results.",
  },
];